// @ts-nocheck
import { populate } from 'populate';
import type { Container, Text, Sprite } from 'pixi.js';
import { ButtonLargeLayout } from '../common/buttons/ButtonLargeLayout';

const raw = {
  width: 780,
  height: 1280,
  x: 0,
  y: 0,
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      runtimeType: null,
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: null,
      stateByName: {}
    },
    {
      id: 'a671e798-2586-47be-a876-d89b14bc868e',
      type: 'Container',
      runtimeType: null,
      name: 'popup',
      className: '',
      x: 390,
      y: 640,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: undefined,
      stateByName: {}
    },
    {
      id: '1acb71d2-8d78-48f7-84fb-7dbbb7d52d18',
      type: 'Container',
      runtimeType: null,
      name: 'contentContainer',
      className: '',
      x: 0,
      y: -160,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'a671e798-2586-47be-a876-d89b14bc868e',
      data: undefined,
      stateByName: {}
    },
    {
      id: '56f90acc-7bf2-4fed-87fe-8ce5e68c369b',
      type: 'Layout',
      runtimeType: null,
      name: 'shareButton',
      className: '',
      path: 'common/buttons/ButtonLargeLayout.ts',
      percentX: 0,
      percentY: 0,
      x: 0,
      y: 318,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: true,
      parent: 'a671e798-2586-47be-a876-d89b14bc868e',
      data: {
        color: 'blue',
        tapSound: 'UI_Button_Click'
      },
      stateByName: {}
    },
    {
      id: '5406544a-79d1-4c17-b2a5-958c68d8d1a4',
      type: 'Text',
      runtimeType: null,
      name: 'tapToContinueButton',
      className: '',
      x: 0,
      y: 410,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'Rectangle',
        x: -150,
        y: -30,
        width: 300,
        height: 90
      },
      text: 'Tap to continue',
      localize: true,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'Kanit{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'a671e798-2586-47be-a876-d89b14bc868e',
      data: {
        tapSound: 'UI_Button_Click'
      },
      stateByName: {}
    },
    {
      id: 'a0abe27c-3add-4845-88a0-e3b52f320bc2',
      type: 'Sprite',
      runtimeType: null,
      name: 'rays',
      className: '',
      x: 0,
      y: 20,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.3,
        y: 1.3
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Ray',
      parent: '1acb71d2-8d78-48f7-84fb-7dbbb7d52d18',
      data: undefined,
      stateByName: {}
    },
    {
      id: '9285ce15-090a-421a-84c0-25661a9ec89b',
      type: 'Container',
      runtimeType: null,
      name: 'shareContainer',
      className: '',
      x: 0,
      y: 20,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '1acb71d2-8d78-48f7-84fb-7dbbb7d52d18',
      data: undefined,
      stateByName: {}
    },
    {
      id: '7448d2a8-25f2-4ed8-ba6d-16f67cef7d72',
      type: 'Sprite',
      runtimeType: null,
      name: '',
      className: '',
      x: 0,
      y: 24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Share_Diorama_Pop_Up',
      parent: '1acb71d2-8d78-48f7-84fb-7dbbb7d52d18',
      data: undefined,
      stateByName: {}
    },
    {
      id: '337281d1-323e-4553-b42f-5f7bdacdd2bd',
      type: 'Sprite',
      runtimeType: null,
      name: 'shareButtonIcon',
      className: '',
      x: -97,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Facebook_Icon',
      parent: '56f90acc-7bf2-4fed-87fe-8ce5e68c369b',
      data: undefined,
      stateByName: {}
    },
    {
      id: 'eb6dfaf1-0e57-44d4-bf65-cd0826ef7fea',
      type: 'Text',
      runtimeType: null,
      name: 'shareButtonLabel',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Share',
      localize: true,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      style: {
        fontSize: 40,
        fontWeight: 'normal',
        fontFamily: 'Kanit{wf}',
        fill: 'white',
        stroke: '#0147b1',
        strokeThickness: 6,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '56f90acc-7bf2-4fed-87fe-8ce5e68c369b',
      data: undefined,
      stateByName: {}
    },
    {
      id: '6a23900d-dbbf-4b58-a5b8-1955d46039ae',
      type: 'Sprite',
      runtimeType: null,
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Share_Diorama_Post',
      parent: '9285ce15-090a-421a-84c0-25661a9ec89b',
      data: undefined,
      stateByName: {}
    },
    {
      id: '8846537e-81cb-47de-aae1-ce8fa84ac8a6',
      type: 'Container',
      runtimeType: null,
      name: 'dioramaSlot',
      className: '',
      x: 0,
      y: 183,
      scale: {
        x: 0.83,
        y: 0.83
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '9285ce15-090a-421a-84c0-25661a9ec89b',
      data: undefined,
      stateByName: {}
    },
    {
      id: '89ff607c-88b9-48f7-89d8-0cba19b87216',
      type: 'Sprite',
      runtimeType: null,
      name: '',
      className: '',
      x: 0,
      y: 223,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Hexa_Logo',
      parent: '9285ce15-090a-421a-84c0-25661a9ec89b',
      data: undefined,
      stateByName: {}
    }
  ],
  version: '1.0.0',
  stateNames: [],
  animations: []
} as const;

export class DioramaSharePopupLayout {
  static raw = raw;
  root: Container;
  popup: Container;
  contentContainer: Container;
  shareButton: ButtonLargeLayout & { data: typeof raw['list'][3]['data'] };
  tapToContinueButton: Text & { data: typeof raw['list'][4]['data'] };
  rays: Sprite;
  shareContainer: Container;
  shareButtonIcon: Sprite;
  shareButtonLabel: Text;
  dioramaSlot: Container;

  mInternalTypes: {
    Raw: typeof raw;
    StateName: never;
    ModelByName: {
      root: typeof raw['list'][0];
      popup: typeof raw['list'][1];
      contentContainer: typeof raw['list'][2];
      shareButton: typeof raw['list'][3];
      tapToContinueButton: typeof raw['list'][4];
      rays: typeof raw['list'][5];
      shareContainer: typeof raw['list'][6];
      shareButtonIcon: typeof raw['list'][8];
      shareButtonLabel: typeof raw['list'][9];
      dioramaSlot: typeof raw['list'][11];
    };
  };

  constructor() {
    populate(this, raw);
  }
}
